import React, { FC, Suspense } from 'react';
// import { createBrowserRouter, Link } from 'react-router-dom';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import RequiredAuthMiddleware from 'middleware/RequiredAuth';
import LoginWithTokenMiddleware from 'middleware/LoginWithToken';
import TokenAccessMiddleware from 'middleware/TokenAccess';
import PreloaderComponent from 'components/Preloader/Preloader.component';
import RouteErrorBoundaryComponent from 'components/RouteErrorBoundary/RouteErrorBoundary.component';
import ErrorsView from 'views/Errors/Errors.view';
import RouteList from './routes';
// import HelloWorldView from 'views/HelloWorld/HelloWorld.view';

// const HelloWorldComponent = (): JSX.Element => (
//   <div>
//     <Link to="/"> Hello world!HelloWorld</Link>
//   </div>
// );

// const router = createBrowserRouter([
//   {
//     path: '/',
//     element: <HelloWorldView />,
//   },
//   {
//     path: '/hello',
//     element: <HelloWorldComponent />,
//   },
// ]);

const Router: FC = () => (
  // const [isAuth, setIsAuth] = useState(window.localStorage.getItem('auth'));

  // const router = useMemo(() => {
  //   let list = [];
  //   if (isAuth === 'true') {
  //     list = RouteList;
  //   } else {
  //     list = RouteList.filter((routeItem) => !routeItem.requireAuth);
  //   }

  //   return createBrowserRouter(
  //     list.map(({ path, Component }) => ({
  //       path,
  //       element: <Component />,
  //       errorElement: <RouteErrorBoundaryComponent />,
  //     })),
  //   );
  // }, [isAuth]);

  // useEffect(() => {
  //   setInterval(() => {
  //     setIsAuth(window.localStorage.getItem('auth'));
  //   }, 5000);
  // }, []);

  // return <RouterProvider router={router} />;

  <BrowserRouter>
    <Routes>
      <Route path="*" element={<ErrorsView />} errorElement={<RouteErrorBoundaryComponent />} />
      {RouteList.map(({ path, Component, requireAuth }) => (
        <Route
          key={`route-path-${path}`}
          path={path}
          element={
            requireAuth ? (
              <TokenAccessMiddleware>
                <LoginWithTokenMiddleware>
                  <RequiredAuthMiddleware>
                    <Suspense fallback={<PreloaderComponent />}>
                      <Component />
                    </Suspense>
                  </RequiredAuthMiddleware>
                </LoginWithTokenMiddleware>
              </TokenAccessMiddleware>
            ) : (
              <Component />
            )
          }
          errorElement={<RouteErrorBoundaryComponent />}
        />
      ))}
      {/* {RouteList.map(({ path, Component, requireAuth }) => (
          <Route
            key={`route-path-${path}`}
            path={path}
            element={requireAuth && isAuth === 'false' ? <ErrorsView /> :<Component />}
            errorElement={<RouteErrorBoundaryComponent />}
          />
        ))} */}
      {/* {isAuth === 'true' &&
          RouteList.filter((routeItem) => routeItem.requireAuth).map(({ path, Component }) => (
            <Route
              key={`route-path-${path}`}
              path={path}
              element={<Component />}
              errorElement={<RouteErrorBoundaryComponent />}
            />
          ))} */}
    </Routes>
  </BrowserRouter>
);

export default Router;
